import React from "react";

import "./site-banner.scss";

class SiteBanner extends React.Component {
  render() {
    return (
      <div className="d-flex justify-content-between site-banner">
        <a
          href="https://sinia.minam.gob.pe"
          rel="noopener noreferrer"
          alt="SINIA | Sistema Nacional de Información Ambiental"
        ><img src="imagenes/portada/sinia-300x60.png" alt="SINIA | Sistema Nacional de Información Ambiental" /></a>
        <a
          href="https://www.gob.pe/minam"
          target="_blank" 
          rel="noopener noreferrer"
        ><img
            src="imagenes/portada/minam.png"
            className="img-peru-primero"
            alt="MINAM EL PERÚ PRIMERO"
          /></a>
      </div>
    );
  }
}
export default SiteBanner;
